<template>
  <div>
    <div class="toolbar">
      <el-button type="primary" size="small" v-on:click="addRole(0)" icon="plus">新增角色</el-button>
    </div>
    <!-- 角色列表 -->
    <div>
      <el-table :data="getRoleList" v-loading="loadingTable" element-loading-text="拼命加载中" border style="width: 100%">
        <el-table-column type="index" label="序号" width="120">
        </el-table-column>
        <el-table-column prop="RoleName" label="角色">
        </el-table-column>
        <el-table-column label="操作" property="Id">
          <template scope="scope">
            <el-button type="success" size="small" @click="handleEditPerson(scope.$index, scope.row)" icon="edit">编辑人员</el-button>
            <el-button type="primary" size="small" @click="handleEditPower(scope.$index, scope.row)" icon="setting">修改权限</el-button>
            <el-button type="danger" size="small" @click="del(scope.$index, scope.row)" icon="delete">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-col :span="24" class='btm-action'>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize*1" style="float: right">
      </el-pagination>
    </el-col>
    <!-- 新增角色modal -->
    <div>
      <el-dialog :title="addRoleForm.title" v-model="roleDialog">
        <el-form :data="addRoleForm" label-width="100px" ref="addRoleForm">
          <el-form-item label="角色名称">
            <el-input v-model="addRoleForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="权限设置">
            <el-checkbox v-model="addRoleForm.checked" @change='checkAll'>全选</el-checkbox>
            <el-tree :data="addRoleForm.type" show-checkbox='' default-expand-all='' :expand-on-click-node='false' node-key="MenuId" ref="tree" highlight-current :props="defaultProps"  @check-change="handleCheckChange">
            </el-tree>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="roleDialog = false">取 消</el-button>
          <el-button type="primary" :loading="btnLoading" @click='getChecked(0)'>确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!--编辑角色modal  -->
    <div>
      <el-dialog title="编辑人员" v-model="roleControlDialog">
        <el-form :data="roleControlForm" label-width="100px" ref="addRoleForm">
          <el-form-item label="角色">
            <el-input v-model="roleControlForm.roleName" auto-complete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="包含人员">
            <div v-if='roleControlForm.dynamicTags.length == 0'>暂无人员</div>
            <div v-else>
              <el-tag :key="tag" v-for="tag in roleControlForm.dynamicTags" :closable="true" :close-transition="false" @close="handleClose(tag)">
                {{ tag.EmployeeName }}
              </el-tag>
              <br>
            </div>
            <el-autocomplete icon="search" v-model="roleControlForm.state" :fetch-suggestions="querySearchAsync" placeholder="新增人员" @select="handleSelect"></el-autocomplete>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="roleControlDialog = false">取 消</el-button>
          <el-button type="primary" :loading="btnLoading" @click="submitRoleControlForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script> 
import RoleControl from './RoleControl.js';
module.exports = RoleControl;
</script>
<style type="text/css" scoped>
.checkTitle {
  font-weight: bold
}

.el-tag+.el-tag {
  margin-left: 10px;
}

.btm-action {
  display: flex;
  justify-content: center;
  margin: 5px 0px;
}
</style>



// WEBPACK FOOTER //
// roleControl.vue?46b89b21